import ColorHashOrig from 'color-hash'
import _ from 'lodash'
const LIGHTNESS_RGB = [0.55, 0.45, 0.4]
const SATURATION_RGB = [0.4, 0.4, 0.4]

/**
 * Simple wrapper around open source color hasher
 */
class ColorHash {
  constructor() {
    this._colorHash = new ColorHashOrig({
      lightness: LIGHTNESS_RGB,
      saturation: SATURATION_RGB,
    })
  }

  hex = text => this._colorHash.hex(_.toLower(text))
}

export default ColorHash
